import { suggestionService, upload } from "../../services";
import { updateDate } from "../../helpers";
import store from "../store";

export const findSolutionSuggestions = {
  namespaced: true,
  state: {
    findSolutionData: [],
    totalRecords: null,
    pageIndex: 0,
    categories: [],
  },
  getters: {
    findSolutionData(state) {
      return state.findSolutionData;
    },
    totalRecords(state) {
      return state.totalRecords;
    },
    pageIndex(state) {
      return state.pageIndex;
    },
    categories(state) {
      return state.categories;
    },
  },
  mutations: {
    async SET_DATA(state, payload) {
      for await (const element of payload) {
        if (element.UserPictureId != 0) {
          const res = await upload.fetchProfileImage(
            parseInt(element.UserPictureId)
          );
          if (res.Data.DownloadBinary) {
            element.UserProfileImage = res.Data.DownloadBinary;
          } else {
            element.UserProfileImage = null;
          }
        } else {
          element.UserProfileImage = null;
        }
        element.CreatedOnUtc = updateDate(element.CreatedOnUtc);
        element.ModifiedDateUtc = updateDate(element.ModifiedDateUtc);
        element.PendingProcessDate = updateDate(element.PendingProcessDate);
        element.ProjectStartDate = updateDate(element.ProjectStartDate);
        element.SuggestionDate = updateDate(element.SuggestionDate);
        element.SuggestionExecutiveProcessDate = updateDate(
          element.SuggestionExecutiveProcessDate
        );
        for await (const comment of element.Comments) {
          comment.CreatedOnUtc = updateDate(comment.CreatedOnUtc);
          if (comment.UserPictureId != 0) {
            const res = await upload.fetchProfileImage(
              parseInt(comment.UserPictureId)
            );
            if (res.Data.DownloadBinary) {
              comment.UserProfileImage = res.Data.DownloadBinary;
            } else {
              comment.UserProfileImage = null;
            }
          } else {
            comment.UserProfileImage = null;
          }
        }
        for await (const item of element.Likes) {
          if (item.UserPictureId != 0) {
            const res = await upload.fetchProfileImage(
              parseInt(item.UserPictureId)
            );
            if (res.Data.DownloadBinary) {
              item.UserProfileImage = res.Data.DownloadBinary;
            } else {
              item.UserProfileImage = null;
            }
          } else {
            item.UserProfileImage = null;
          }
          if (item.UserId == store.getters["user/user"].Data.UserId) {
            element.IsLiked = true;
          } else {
            element.IsLiked = false;
          }
        }
      }

      state.findSolutionData.push(...payload);
    },
    SET_TOTAL_RECORDS(state, payload) {
      state.totalRecords = payload;
    },
    SET_PAGE_INDEX(state, payload) {
      state.pageIndex = payload;
    },
    DELETE_DATA(state) {
      state.findSolutionData = [];
      state.pageIndex = 0;
    },
    SET_CATEGORIES(state, payload) {
      state.categories = payload;
    },
  },
  actions: {
    async setData(vuexContext) {
      const pageSize = 5;
      const body = {
        PageIndex: findSolutionSuggestions.state.pageIndex,
        PageSize: pageSize,
        LoginUserId: store.getters["user/user"].Data.UserId,
        EndUser: true,
      };
      const res = await suggestionService.fetchGetFindSolutionSuggestions(
        body
      );
      res.Data && vuexContext.commit("SET_DATA", res.Data.Data);
      res.Data &&
        vuexContext.commit("SET_TOTAL_RECORDS", res.Data.TotalRecords);
    },
    setPageIndex(vuexContext, data) {
      vuexContext.commit("SET_PAGE_INDEX", data);
    },
    deleteFindSolutionData(vuexContext) {
      vuexContext.commit("DELETE_DATA");
    },
    async getCategories(vuexContext) {
      if (vuexContext.state.categories.length > 0) return;
      const res = await suggestionService.fetchGetFindSolutionCategories();
      res.Data && vuexContext.commit("SET_CATEGORIES", res.Data);
    },
  },
};
